// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgOtherCategoryIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M13.65 6.45a1.1 1.1 0 0 1 1.1 1.1v2.2h1.65a1.1 1.1 0 0 1 1.1 1.1v2.2c0 2.661-1.89 4.88-4.4 5.39v3.41a1.1 1.1 0 1 1-2.2 0v-3.41a5.5 5.5 0 0 1-4.4-5.39v-2.2a1.1 1.1 0 0 1 1.1-1.1h1.65v-2.2a1.1 1.1 0 0 1 2.2 0v2.2h1.1v-2.2a1.1 1.1 0 0 1 1.1-1.1M12 2.05c6.073 0 11 4.917 11 10.985a10.96 10.96 0 0 1-4.125 8.574A1.1 1.1 0 0 1 17.5 19.89a8.76 8.76 0 0 0 3.3-6.856c0-4.85-3.938-8.785-8.8-8.785s-8.8 3.935-8.8 8.784a8.76 8.76 0 0 0 3.3 6.857 1.1 1.1 0 0 1-1.375 1.718A10.96 10.96 0 0 1 1 13.034C1 6.967 5.927 2.05 12 2.05m-3.3 9.9v1.1h6.6v-1.1z" />
  </g>
);
export default SvgOtherCategoryIcon;
SvgOtherCategoryIcon.displayName = 'SvgOtherCategoryIcon';
